export default {
  REGISTER_EXTENSION: '@WS/REGISTER_EXTENSION',
  SET_EXTENSION_CONFIGURATIONS: '@WS/SET_EXTENSION_CONFIGURATIONS',
  UPDATE_EXTENSION: '@WS/UPDATE_EXTENSION',
  ADD_DICTIONARY: '@WS/EXTENSIONS/ADD_DICTIONARY',
  LOAD_EXTENSIONS: '@WS/EXTENSIONS/LOAD_EXTENSIONS',
};
